import {
  type LiquidateAllDialogProps,
  useLiquidateAllDialogController,
} from "./LiquidateAllDialog.controller";
import { LiquidateAllDialogPresentation } from "./LiquidateAllDialog.pres";

export type { LiquidateAllDialogProps };

export const LiquidateAllDialog = (props: LiquidateAllDialogProps) => {
  const controller = useLiquidateAllDialogController(props);
  return <LiquidateAllDialogPresentation {...controller} />;
};
